import { Routes } from '@angular/router';

export const publicRoutes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./shared/layouts/public-layout/public-layout.component').then(
        (m) => m.PublicLayoutComponent,
      ),
    children: [
      {
        path: '',
        pathMatch: 'full',
        loadComponent: () =>
          import('./features/public/home/home.component').then(
            (m) => m.HomeComponent,
          ),
      },
      {
        path: 'about',
        loadComponent: () =>
          import('./features/public/about/about.component').then(
            (m) => m.AboutComponent,
          ),
      },
      {
        path: 'services',
        loadComponent: () =>
          import('./features/public/services/services.component').then(
            (m) => m.ServicesComponent,
          ),
      },
      {
        path: 'service-detail',
        loadComponent: () =>
          import('./features/public/service-detail/service-detail.component').then(
            (m) => m.ServiceDetailComponent,
          ),
      },
      {
        path: 'team',
        loadComponent: () =>
          import('./features/public/team/team.component').then(
            (m) => m.TeamComponent,
          ),
      },
      {
        path: 'blog',
        loadComponent: () =>
          import('./features/public/blog/blog.component').then(
            (m) => m.BlogComponent,
          ),
      },
      {
        path: 'shop-products',
        loadComponent: () =>
          import('./features/public/shop-products/shop-products.component').then(
            (m) => m.ShopProductsComponent,
          ),
      },
      {
        path: 'shop-products/category/:categoryId',
        loadComponent: () =>
          import('./features/public/shop-products/shop-products.component').then(
            (m) => m.ShopProductsComponent,
          ),
      },
      {
        path: 'shop-products/product/:productId',
        loadComponent: () =>
          import('./features/public/shop-products/shop-products.component').then(
            (m) => m.ShopProductsComponent,
          ),
      },
      {
        path: 'public/producers/:id',
        loadComponent: () =>
          import('./features/public/producer-profile/producer-profile.component').then(
            (m) => m.ProducerProfileComponent,
          ),
      },
      {
        path: 'geo',
        data: {
          resource: {
            title: 'Zones desservies',
            singular: 'un pays',
            endpoint: '/public/geo/countries',
            readOnly: true,
            fields: [
              { key: 'name', label: 'Pays' },
              { key: 'isoCode', label: 'Code ISO' },
              { key: 'phoneCode', label: 'Indicatif' },
            ],
          },
        },
        loadComponent: () =>
          import('./features/recovered/resource-page.component').then(
            (m) => m.RecoveredResourcePageComponent,
          ),
      },
      {
        path: 'shop-detail/:id',
        loadComponent: () =>
          import('./features/public/shop-detail/shop-detail.component').then(
            (m) => m.ShopDetailComponent,
          ),
      },
      {
        path: 'shop-detail',
        loadComponent: () =>
          import('./features/public/shop-detail/shop-detail.component').then(
            (m) => m.ShopDetailComponent,
          ),
      },
      {
        path: 'wishlist',
        redirectTo: 'shop-products',
        pathMatch: 'full',
      },
      {
        path: 'contact',
        loadComponent: () =>
          import('./features/public/contact/contact.component').then(
            (m) => m.ContactComponent,
          ),
      },
      {
        path: 'faq',
        loadComponent: () =>
          import('./features/public/faq/faq.component').then(
            (m) => m.FaqComponent,
          ),
      },
      {
        path: 'privacy-policy',
        data: { slug: 'privacy-policy' },
        loadComponent: () =>
          import('./features/public/cms-page/cms-page.component').then(
            (m) => m.CmsPageComponent,
          ),
      },
      {
        path: 'terms-and-conditions',
        data: { slug: 'terms-and-conditions' },
        loadComponent: () =>
          import('./features/public/cms-page/cms-page.component').then(
            (m) => m.CmsPageComponent,
          ),
      },

      {
        path: 'email-verification',
        loadComponent: () =>
          import('./auth/email-verification/email-verification-3/email-verification-3.component').then(
            (m) => m.EmailVerification3Component,
          ),
      },
      {
        path: 'reset-password',
        loadComponent: () =>
          import('./auth/reset-password/reset-password-3/reset-password-3.component').then(
            (m) => m.ResetPassword3Component,
          ),
      },
      {
        path: 'forgot-password',
        loadComponent: () =>
          import('./auth/forgot-password/forgot-password-3/forgot-password-3.component').then(
            (m) => m.ForgotPassword3Component,
          ),
      },
      {
        path: 'register',
        loadComponent: () =>
          import('./auth/register/register-3/register-3.component').then(
            (m) => m.Register3Component,
          ),
      },
      {
        path: 'login',
        loadComponent: () =>
          import('./auth/signin/signin-3/signin-3.component').then(
            (m) => m.Signin3Component,
          ),
      },
      {
        path: 'two-step-verification-3',
        loadComponent: () =>
          import('./auth/two-step-verification/two-step-verification-3/two-step-verification-3.component').then(
            (m) => m.TwoStepVerification3Component,
          ),
      },
      {
        path: 'lock-screen',
        loadComponent: () =>
          import('./auth/lock-screen/lock-screen.component').then(
            (m) => m.LockScreenComponent,
          ),
      },
      {
        path: 'auth/verify',
        loadComponent: () =>
          import('./auth/confirmation-account/confirmation-account.component').then(
            (m) => m.ConfirmationAccountComponent,
          ),
      },
      {
        path: 'success',
        loadComponent: () =>
          import('./auth/successs/success-3/success-3.component').then(
            (m) => m.Success3Component,
          ),
      },
      { path: 'products', redirectTo: 'shop-products', pathMatch: 'full' },
      { path: 'public', redirectTo: '', pathMatch: 'full' },
      { path: 'public/about', redirectTo: 'about', pathMatch: 'full' },
      { path: 'public/services', redirectTo: 'services', pathMatch: 'full' },
      {
        path: 'public/products',
        redirectTo: 'shop-products',
        pathMatch: 'full',
      },
      { path: 'public/contact', redirectTo: 'contact', pathMatch: 'full' },
      { path: 'auth/login', redirectTo: 'login', pathMatch: 'full' },
      { path: 'auth/success-3', redirectTo: 'success', pathMatch: 'full' },
      { path: 'success-3', redirectTo: 'success', pathMatch: 'full' },
      { path: 'register-3', redirectTo: 'register', pathMatch: 'full' },
      { path: 'signin-3', redirectTo: 'login', pathMatch: 'full' },
      {
        path: 'forgot-password-3',
        redirectTo: 'forgot-password',
        pathMatch: 'full',
      },
      {
        path: 'reset-password-3',
        redirectTo: 'reset-password',
        pathMatch: 'full',
      },
      {
        path: 'two-step-verification',
        redirectTo: 'two-step-verification-3',
        pathMatch: 'full',
      },
      {
        path: 'two-step-verification-2',
        redirectTo: 'two-step-verification-3',
        pathMatch: 'full',
      },
      {
        path: 'email-verification-3',
        redirectTo: 'email-verification',
        pathMatch: 'full',
      },
    ],
  },
];
